import { render, staticRenderFns } from "./EditarProceso.vue?vue&type=template&id=38ad788e&scoped=true&"
import script from "./EditarProceso.vue?vue&type=script&lang=js&"
export * from "./EditarProceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad788e",
  null
  
)

export default component.exports